import React from 'react';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { companyInfo } from '../data/mock';

const HeroSection = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center bg-charcoal overflow-hidden"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `
              linear-gradient(rgba(201, 162, 77, 0.1) 1px, transparent 1px),
              linear-gradient(90deg, rgba(201, 162, 77, 0.1) 1px, transparent 1px)
            `,
            backgroundSize: '60px 60px',
          }}
        />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-64 h-64 bg-burgundy/10 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-gold/5 rounded-full blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32">
        <div className="max-w-4xl">
          {/* Tagline */}
          <div className="flex items-center gap-3 mb-8 animate-fade-in">
            <div className="w-12 h-0.5 bg-gold" />
            <span className="text-gold text-sm tracking-widest uppercase font-medium">
              {companyInfo.tagline}
            </span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-ivory leading-tight mb-8 animate-slide-up">
            {companyInfo.heroTitle.split('.').map((part, index) => (
              <span key={index}>
                {part.trim()}
                {index === 0 && <span className="text-gold">.</span>}
                {index === 0 && <br />}
                {index === 1 && <span className="text-gold">.</span>}
              </span>
            ))}
          </h1>

          {/* Description */}
          <p className="text-lg md:text-xl text-slate leading-relaxed mb-6 max-w-3xl animate-slide-up-delay">
            {companyInfo.heroDescription}
          </p>
          <p className="text-base md:text-lg text-slate/80 leading-relaxed mb-12 max-w-3xl animate-slide-up-delay-2">
            {companyInfo.heroSubDescription}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-slide-up-delay-3">
            <button
              onClick={() => scrollToSection('#contact')}
              className="group bg-gold text-charcoal px-8 py-4 font-semibold text-lg flex items-center justify-center gap-3 hover:bg-gold/90 transition-all duration-400 hover:shadow-xl hover:shadow-gold/20"
            >
              {companyInfo.ctaPrimary}
              <ArrowRight
                size={20}
                className="group-hover:translate-x-1 transition-transform duration-300"
              />
            </button>
            <button
              onClick={() => scrollToSection('#services')}
              className="group bg-ivory/10 text-ivory px-8 py-4 font-semibold text-lg flex items-center justify-center gap-3 hover:bg-ivory hover:text-charcoal transition-all duration-400"
            >
              {companyInfo.ctaSecondary}
              <ArrowRight
                size={20}
                className="group-hover:translate-x-1 transition-transform duration-300"
              />
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <button
          onClick={() => scrollToSection('#about')}
          className="text-gold/60 hover:text-gold transition-colors"
          aria-label="Scroll down"
        >
          <ChevronDown size={32} />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
